export default "__VITE_ASSET__5ec5c24a__"